import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "@deepsearch-hq/axp-ui-library/styles.css";
import "./styles/axp-bridge.css";
import "./styles/base.css";
import "./styles/shell.css";
import App from "./App";
import { escapeKakao, isKakaoInApp } from "./lib/inApp";

// 카카오톡 인앱 브라우저 → 외부 브라우저로 즉시 탈출 — 구글이 웹뷰에서
// OAuth 를 차단해(disallowed_useragent) 구글 로그인이 안 되기 때문.
// 스킴이 무시되는 환경이면 페이지가 그대로 진행되고, LoginOverlay 가
// 안내 배너 + 아이디 로그인 폴백을 보여준다.
if (isKakaoInApp()) escapeKakao();

// FOUC 방지 테마 조기 적용 — 바닐라 index.html 인라인 스크립트와 동일 동작.
// (va_theme_v2 는 "1" 마이그레이션 플래그 — 테마 이름이 아니다. 리뉴얼 이전
//  기본값 ivory 자동 저장분만 1회 light 로 되돌리고, 직접 고른 ivory 는 유지.)
try {
  let theme = localStorage.getItem("va_theme") || "light";
  if (theme === "ivory" && !localStorage.getItem("va_theme_v2")) theme = "light";
  if (theme === "ivory" || theme === "dark") {
    document.documentElement.setAttribute("data-theme", theme);
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
} catch {
  /* noop */
}

// 스크롤바 표시 제어 — 스크롤하는 동안만 .is-scrolling (base.css 가 손잡이를 그린다).
// capture 리스너 하나로 모든 스크롤 영역을 커버한다. 700ms 멈추면 사라진다.
{
  const timers = new WeakMap<HTMLElement, number>();
  document.addEventListener(
    "scroll",
    (e) => {
      const el =
        e.target === document ? document.documentElement : (e.target as HTMLElement);
      if (!(el instanceof HTMLElement)) return;
      el.classList.add("is-scrolling");
      window.clearTimeout(timers.get(el));
      timers.set(
        el,
        window.setTimeout(() => el.classList.remove("is-scrolling"), 700),
      );
    },
    { capture: true, passive: true },
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
